import { useState, useMemo, useEffect, useRef } from "react";
import "./SearchList.scss";
import { SearchIcon } from "../../lib/myIcons";
import encryptedapiRequest from "../../lib/encryptedapiRequest";

const SearchList = ({
  data = [],  // this the data which is already fetched
  dataFields = [],
  placeholder = "Search...",
  serverConfig={},

  // value='',           // controlled input value from parent
  // onChange= ()=>{ },        // setSearchTerm in parent
  // onNoResults,     // callback when local filtered data is empty
  // onFilteredData,   // callback when local filtered data is not empty
  renderItem, // optional
  onSelect,
}) => {

// const [localFiltered, setLocalFiltered] = useState(data);

  const [searchTerm, setSearchTerm] = useState("");
  const [results, setResults] = useState(data); // active dataset
  // const [source, setSource] = useState("local");   // "local" | "server"
  const [loading, setLoading] = useState(false);
  // const sourceRef = useRef("local"); // replaces source state for fetch decision

  // Normalize data for search (optional, e.g., array fields)
  const normalizeValue = (val) => {
    if (Array.isArray(val)) {
      return val.map(v => (typeof v === "object" && v !== null ? Object.values(v) : v)).flat();
    }
    return [val];
  };

  // 🔹 Filter local paginated data
  const filteredLocal = useMemo(() => {
    const term = (searchTerm || "").toLowerCase();

    return data.filter(item =>
      dataFields.some(field => {
        const val = item[field];
        return normalizeValue(val).some(v =>
          String(v).toLowerCase().includes(term)
        );

      })
    );
  }, [ data, dataFields,searchTerm]);


 // Effect: handle search
  useEffect(() => {
    const fetchServer = async () => {
      if (!serverConfig?.url) return;

      setLoading(true);
      try {
        const response = await encryptedapiRequest.get(serverConfig.url, {
          params: { ...serverConfig.params, fullsearch: searchTerm ,limit:serverConfig.limit},
        });
        const serverdata = response.data?.data || [];
        setResults(serverdata);
        // sourceRef.current = "server";
        // setSource("server");
      } catch (err) {
        console.error("Server search error:", err);
        setResults([]);
      } finally {
        setLoading(false);
      }
    };

    if (!searchTerm) {
      // Input cleared → revert to local seed
      setResults(data);
      // sourceRef.current = "local";
      // setSource("local");
      setLoading(false);
    } else {
      // If local search yields results → show them
      if (filteredLocal.length > 0) {
        setResults(filteredLocal);
        // sourceRef.current = "local";
        // setSource("local");
      } else {
        // Local empty → escalate to server
        // if (sourceRef.current === "local") {
          fetchServer();
        // }
      }
    }
  
  }, [searchTerm, filteredLocal, data, serverConfig]);

  // Handle click on a result
  const handleSelect = (item) => {
    if (onSelect) onSelect(item);
  };



  // 🔹 Update local filtered data and notify parent if no match
  // useEffect(() => {
  //   setLocalFiltered(filteredData);

  //   if (value && filteredData.length === 0) {
  //     onNoResults?.(value); // notify parent to fetch server data
  //   }
  // }, [filteredData, value, onNoResults]);


//   useEffect(() => {
//   if (value && filteredData.length === 0) {
//     onNoResults?.(value);
//   }

//   // 🔹 always pass filtered data to parent
//     onFilteredData?.(filteredData);

// }, [filteredData, value, onNoResults,onFilteredData]);


// useEffect(() => {
//   if (!value) return; // nothing typed

//   if (filteredData.length === 0) {
//     onNoResults?.(value);
//   } else {
//     // Only call if filteredData changed
//     onFilteredData?.(filteredData);
//   }
// }, [filteredData, value, onNoResults, onFilteredData]);


// const arraysEqual = (a, b) => {
//   if (a === b) return true;
//   if (!a || !b || a.length !== b.length) return false;
//   for (let i = 0; i < a.length; i++) {
//     if (a[i].id !== b[i].id) return false; // compare unique id
//   }
//   return true;
// };


// useEffect(() => {
//   if (!value) return;

//   if (filteredData.length === 0) {
//     onNoResults?.(value);
//   } else {
//     onFilteredData?.((prev) => {
//       if (prev === filteredData) return prev; // avoid update
//       return filteredData;
//     });
//   }
// }, [filteredData, value, onNoResults, onFilteredData]);



// useEffect(() => {
//   if (!value) return;

//   if (filteredData.length === 0) {
//     onNoResults?.(value); // trigger server search if needed
//   } else {
//     onFilteredData?.(filteredData); // pass filtered array directly
//   }
// }, [filteredData, value, onNoResults, onFilteredData]);


  return (
    <div className="SearchList">
      <div className="SearchInputWrapper">
        <span className="SearchIcon">
          <SearchIcon size={24} />
        </span>
        <input
          type="text"
          value={searchTerm}
          placeholder={placeholder}
          onChange={(e) => setSearchTerm(e.target.value)} // parent handles update
          // onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>


      {searchTerm && (
        <div className="SearchResultsOverlay">
          {loading ? (
            <p className="Loading">Searching...</p>
          ) : results.length > 0 ? (
            results.map((item, index) =>
              renderItem ? (
                renderItem(item, index, () => handleSelect(item))
              ) : (
                <div
                  key={index}
                  className="SearchResultRow"
                  onClick={() => handleSelect(item)}
                >
                  {JSON.stringify(item)}
                </div>
              )
            )
          ) : (
            <p className="NoResults">No matching items found</p>
          )}
        </div>
      )}


    </div>
  );
};

export default SearchList;
